/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ApiDocsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string Return this API documentation
     * @throws ApiError
     */
    public getV1ApiDocs(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/api-docs',
        });
    }

}
